module.exports = __webpack_public_path__ + "img/mm-casino1.3eb4e208.png";